module.exports = __webpack_public_path__ + "static/media/bg3.4754594d.jpeg";